import { render, staticRenderFns } from "./s-delete-dialog.vue?vue&type=template&id=361806f9"
import script from "./s-delete-dialog.vue?vue&type=script&lang=js"
export * from "./s-delete-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports